import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white  md:py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 py-16">
            <div>
              <h3 className="font-semibold mb-2 tracking-wide">UNGEGN ASED</h3>
              <div className="w-16 h-1 bg-blue-600 rounded mb-4"></div>

              <p className="text-gray-400 leading-relaxed">
                United Nations Group of Experts on Geographical Names - Asia
                South-East Division
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2 tracking-wide">Quick Links</h4>
              <div className="w-16 h-1 bg-blue-600 rounded mb-4"></div>
              <ul className="space-y-2 text-gray-400">
                {["Meetings", "Publications", "Resources", "Contact"].map(
                  (link) => (
                    <li key={link}>
                      <Link
                        to={`/${link.toLowerCase()}`}
                        className="text-white hover:text-white transition-colors"
                      >
                        {link}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-2 tracking-wide">
                External Links
              </h4>
              <div className="w-16 h-1 bg-blue-600 rounded mb-4"></div>

              {/* <ul className="space-y-2 text-gray-400">
               */}
              <ul className="grid grid-cols-2 gap-x-8 gap-y-2">
                <li>
                  <a
                    href="https://www.un.org/en/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    United Nations
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    UNGEGN Main Site
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/sessions/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    UNGEGN Meeting
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/bureau/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    Bureau and Convenors
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/mandate/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    Mandate
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/resolutions/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    Resolutions
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    Resources
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/divisions/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    Divisions
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/links/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    Links
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/working_groups/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    Working Groups
                  </a>
                </li>
                <li>
                  <a
                    href="https://unstats.un.org/unsd/ungegn/contact/"
                    target="_blank"
                    className="text-white hover:text-white transition-colors"
                    rel="noreferrer"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* <div className="border-t border-gray-800 text-center text-gray-400 text-sm tracking-wide"> */}
          <div className="border-t border-gray-600 py-3 text-center">
            © {new Date().getFullYear()} UNGEGN ASE Division. All rights
            reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
